(() => {
  if (window.ddHeaderNavReady) return;
  window.ddHeaderNavReady = true;
  const storageKey = 'ddpai-header-section';
  const identity = url => url.pathname.replace(/\/$/, '') + url.search + url.hash;
  const links = header => [...header.querySelectorAll('.dd-nav>a,.dd-mobile-menu nav>a,.dd-header-install,.dd-camera-dropdown>a,.dd-camera-menu-intro>a')];
  const name = link => link.closest('.dd-camera-menu') ? window.ddpaiT('Dash cams') : link.textContent.trim().replace(/\s+/g, ' ');
  const clear = header => {
    links(header).forEach(link => {link.classList.remove('is-selected');link.removeAttribute('aria-current');});
    header.querySelector('.dd-camera-menu')?.classList.remove('is-selected');
  };
  const select = (header, selectedName, hash = false, target = identity(new URL(location.href))) => {
    clear(header);
    links(header).filter(link => name(link) === selectedName).forEach(link => {
      link.classList.add('is-selected');
      if (identity(new URL(link.href)) === target) link.setAttribute('aria-current', hash ? 'location' : 'page');
      if (link.closest('.dd-camera-menu')) header.querySelector('.dd-camera-menu')?.classList.add('is-selected');
    });
  };
  const sync = () => document.querySelectorAll('.dd-header-reference').forEach(header => {
    const current = identity(new URL(location.href));
    let saved;
    try {saved = JSON.parse(sessionStorage.getItem(storageKey));} catch {}
    if (saved?.url === current) {select(header, saved.name, Boolean(location.hash));return;}
    const matches = links(header).filter(link => {
      const url = new URL(link.href);
      return url.origin === location.origin && identity(url) === current;
    });
    const names = [...new Set(matches.map(name))];
    if (names.length === 1) select(header, names[0], Boolean(location.hash));
    else clear(header);
  });
  document.addEventListener('click', event => {
    const link = event.target.closest('a');
    const header = link?.closest('.dd-header-reference');
    if (!header || !links(header).includes(link) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    const url = new URL(link.href);
    if (url.origin !== location.origin) return;
    const selectedName = name(link);
    try {sessionStorage.setItem(storageKey, JSON.stringify({name:selectedName,url:identity(url)}));} catch {}
    select(header, selectedName, Boolean(url.hash), identity(url));
  });
  window.addEventListener('hashchange', sync);
  window.addEventListener('popstate', sync);
  document.addEventListener('shopify:section:load', sync);
  sync();

  document.addEventListener('change', event => {
    if (event.target.matches('[data-dd-language-select]')) event.target.form.requestSubmit();
  });
  const mobile = matchMedia('(max-width: 749px)');
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const initBenefits = () => document.querySelectorAll('.dd-benefits-items').forEach(track => {
    if (track.dataset.autoRotateReady) return;
    track.dataset.autoRotateReady = 'true';
    let resumeAt = 0;
    const pause = () => { resumeAt = Date.now() + 6500; };
    track.addEventListener('pointerdown', pause, {passive:true});
    track.addEventListener('touchstart', pause, {passive:true});
    track.addEventListener('keydown', pause);
    const timer = setInterval(() => {
      if (!track.isConnected) { clearInterval(timer); return; }
      if (!mobile.matches || reducedMotion.matches || document.hidden || Date.now() < resumeAt || track.matches(':focus-within')) return;
      const items = [...track.children];
      if (items.length < 2) return;
      const current = items.reduce((nearest, item, index) => Math.abs(item.offsetLeft - items[0].offsetLeft - track.scrollLeft) < Math.abs(items[nearest].offsetLeft - items[0].offsetLeft - track.scrollLeft) ? index : nearest, 0);
      const next = items[(current + 1) % items.length];
      track.scrollTo({left: next.offsetLeft - items[0].offsetLeft, behavior:'smooth'});
    }, 3500);
  });
  document.addEventListener('shopify:section:load', initBenefits);
  initBenefits();
})();
